var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "HideView",
      class: { "HideView--hidden": _vm.value },
      on: {
        click: function ($event) {
          return _vm.onShow()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "HideViewButton",
          on: {
            click: function ($event) {
              return _vm.$emit("click", $event)
            },
          },
        },
        [
          !_vm.value
            ? _c("svg-view", { attrs: { name: "eye-hide" } })
            : _c("svg-view", { attrs: { name: "eye-show" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }